import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";

import {
  IFilesUploadImportInstallments,
} from "../ParcelasTypes";
import { IListPDF } from "src/Pages/components/DropZoneCore/DropZoneCore";


export const valuesDefaultUploadImportInstallments: IFilesUploadImportInstallments = {
  file: {} as IListPDF,
  operadora_id: "",
  data: `${GetDateUSSemValue()}`,
  type: "xlsx",
};
